import { render, staticRenderFns } from "./RirekishoPrimeUpsellDialog.vue?vue&type=template&id=a3048698"
import script from "./RirekishoPrimeUpsellDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./RirekishoPrimeUpsellDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RirekishoPrimeUpsellDialog.vue?vue&type=style&index=0&id=a3048698&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports